import { BaseService } from "src/services/baseService";
import { UnknownArrivalAPIService } from "./unknownArrivalAPIService";
import { sanitiseParams } from "src/utils/sanitiser";
import { IssueStatus, UnknownArrival } from "src/types";

class UnknownArrivalService extends BaseService<UnknownArrivalAPIService> {
  @sanitiseParams()
  async getWarehouseCheckInUnknownArrival(
    warehouseCheckInId: string,
    unknownArrivalStatus?: IssueStatus
  ): Promise<UnknownArrival | undefined> {
    const unknownArrival = await this.apiService.getWarehouseCheckInUnknownArrival(warehouseCheckInId, {
      unknownArrivalStatus
    });

    return unknownArrival;
  }

  @sanitiseParams()
  async resolveWarehouseCheckInUnknownArrival(
    warehouseCheckInId: string,
    resolutionDetails: string
  ): Promise<UnknownArrival | undefined> {
    const updatedUnknownArrival = await this.apiService.patchWarehouseCheckInUnknownArrivalResolution(
      warehouseCheckInId,
      { resolutionDetails }
    );

    return updatedUnknownArrival;
  }
}

export { UnknownArrivalService };
